/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type forum_filebase_full = {
  id: string;
  category_id: number;
  version: string;
  filename: string;
  description: string;
  build_status: forum_filebase_full.build_status;
};
export namespace forum_filebase_full {
  export enum build_status {
    WAITING = 'waiting',
    SENT = 'sent',
    FAILED = 'failed',
  }
}
